import { MessagesState } from './types';

export default function createMessagesState(overrides: Partial<MessagesState> = {}): MessagesState {
  return {
    isConnected: false,
    isConnecting: false,
    connectionError: null,

    currentChannelUrl: null,
    lastReceivedMessageId: null,
    lastReceivedMessageAt: null,
    lastReceivedChannelUrl: null,

    channels: [],
    rawChannels: [],
    loadingChannels: true,
    channelListError: '',

    messages: [],
    selectedOtherUser: null,
    selectedChannelMembers: [],
    loadingMessages: true,
    messageLoadError: '',

    sending: false,
    sendError: '',

    queryParamChannelNotFound: false,
    ...overrides,
  };
}
